import { useRef } from "react";
import style from "./DiscountsTab.module.scss";
import { FormikProps } from "formik";
import { useParams } from "react-router-dom";
import { Button } from "@ui";
import { QueryParamsManager, Tariff, Wholesale } from "./components";
import { useGetAllUsersQuery, useGetPersonalTariffsQuery, useUpdatePersonalPriceMutation } from "@RTKQuery/admin/customers/customers";
import { useAppSelector } from "store/hooks";

type TariffForm = {
    "3": string,
    "7": string,
    "30": string,
} & {
    [key: string]: string
};

const TARIFF_COLORS: { [id: number]: string } = {
    1: "bg-[#AAB3D3]",
    2: "bg-[#C6B164]",
    3: "bg-[#1E9EEE]",
};

export function DiscountsTab() {
    const { id } = useParams();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);

    const { data: user } = useGetAllUsersQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        search: activeSearchIdParameter,
        is_active: activeFilter
    }, {
        selectFromResult: (res) => ({
            ...res,
            data: res.data?.users.find(item => item.id === Number(id))
        })
    });

    const { data } = useGetPersonalTariffsQuery({
        user_id: Number(id)
    });

    const [updatePersonalPrice, updateStatus] = useUpdatePersonalPriceMutation();

    const tariffRefs = useRef<{ [id: number]: FormikProps<TariffForm> | null }>({});

    if (data && data.length > 0) {
        const handleSubmitAll = async () => {
            for (const tariff of data) {
                await tariffRefs.current[tariff.id]?.submitForm();
            }

            const allValid = data.every(t => tariffRefs.current[t.id]?.isValid);

            if (allValid) {
                updatePersonalPrice(
                    data.flatMap(tariff =>
                        tariff.personal_prices.map(item => ({
                            id: item.id,
                            price: Number(tariffRefs.current[tariff.id]?.values[String(item.rent_time)]) || 0
                        }))
                    )
                );
            }
        };

        return (
            <div className={style.container}>
                <Wholesale />
                {
                    user?.is_wholesaler
                        ? <>
                            <div className={style.listTariffs}>
                                {data.map(tariff => (
                                    <Tariff
                                        key={tariff.id}
                                        colorCircle={TARIFF_COLORS[tariff.id] ?? "bg-gray-400"}
                                        data={tariff}
                                        ref={el => { tariffRefs.current[tariff.id] = el; }}
                                    />
                                ))}
                            </div>
                            <div className="bg-[#FFF] flex justify-center w-fit rounded-[14px] px-[30px] py-[35px] max-md:p-[15px]  max-md:w-full">
                                <Button
                                    type="button"
                                    text="Зберегти"
                                    color="blue"
                                    customStyle={{
                                        button: "!w-[190px] !h-[40px]"
                                    }}
                                    onClick={() => {
                                        handleSubmitAll()
                                    }}
                                    successContent={
                                        updateStatus.isSuccess
                                            ? {
                                                title: "Вітаємо!",
                                                description: <p className="max-w-[260px]">Ви успішно оновили всі ціни!</p>
                                            }
                                            : undefined
                                    }
                                    loading={updateStatus.isLoading}
                                    errors={[
                                        (updateStatus.error && ((extractError) => {
                                            return {
                                                title: "От халепа!",
                                                description: <p className="max-w-[360px]">Схоже що деякі значення не вдалося оновити.</p>
                                            }
                                        }))
                                    ]}
                                    resetStatus={() => {
                                        updateStatus.reset();
                                    }}
                                />
                            </div>
                        </>
                        : null
                }
                <QueryParamsManager />
            </div>
        )
    } else {
        return null;
    }
}
